function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "f@3x");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "footer",
  transform: "translate(-176.000000, -245.000000)"
}, React.createElement("g", {
  id: "Group-6"
}, React.createElement("rect", {
  id: "Rectangle",
  fill: "#A6A6B4",
  x: 0,
  y: 0,
  width: 1440,
  height: 339
}), React.createElement("path", {
  d: "M183.5,261 L183.5,254.925508 L182,254.925508 L182,252.628443 C182.666667,252.675425 183.166667,252.675425 183.5,252.628443 C183.5,250.619478 182.961358,247.569596 188,248.120689 C188,248.620689 188,249.724635 188,250.224635 C185.298833,250.224635 185.811477,250.023128 185.811477,252.628443 C186.478143,252.628443 187.207651,252.628443 188,252.628443 L187.892766,254.925508 L185.811477,254.925508 L185.811477,261 L183.5,261 Z",
  id: "Path-2",
  fill: "#FFFFFF"
}))));

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.019ff920.svg";
export { ForwardRef as ReactComponent };